import React, { useId } from 'react';
import type { YesNo } from '../../types/claimCalculator';
interface YesNoFieldProps {
  label: string;
  value: YesNo;
  onChange: (value: YesNo) => void;
  required?: boolean;
}
export function YesNoField({
  label,
  value,
  onChange,
  required = true
}: YesNoFieldProps) {
  const fieldName = useId();
  return <fieldset data-id="element-125" data-mp="1jctbzeigtc2x">
      <legend className="text-[13px] font-semibold leading-[1.4] text-ink" data-id="element-126" data-mp="1jdbj566o1apm">
        {label}
        {required && <span className="text-signal" data-id="element-127" data-mp="1o90l1g65r3p3"> *</span>}
      </legend>
      <div className="mt-2 grid grid-cols-2 gap-2" data-id="element-128" data-mp="1sbn68y8bpqdb">
        {(['yes', 'no'] as const).map(option => <label key={option} className={`flex min-h-[42px] cursor-pointer items-center justify-center rounded-btn border px-3 text-[13px] font-semibold transition-colors duration-150 ease-out ${value === option ? 'border-forest bg-forest text-paper' : 'border-ink/10 bg-canvas text-ink hover:border-forest/35'}`} data-id="element-129" data-mp="1x4q1rbwnv9w5">
            <input type="radio" name={fieldName} className="sr-only" checked={value === option} onChange={() => onChange(option)} required={required} data-id="element-130" data-mp="8acj3ua9b6cr" />
            {option === 'yes' ? 'Yes' : 'No'}
          </label>)}
      </div>
    </fieldset>;
}